/** Initials for an avatar: "ada@example.com" → "A", "ada.lovelace@example.com" → "AL". */
export function initialsOf(email: string): string {
  const [name = ''] = email.split('@', 1);
  const [first = '', second = ''] = name.split(/[._+-]+/u).filter(Boolean);
  return (first.charAt(0) + second.charAt(0)).toUpperCase() || '?';
}
